<!--
    ProjectCardList - Displays an array of projects in a 3-column layout
    Note: must pass `projects` AND :key="" with a unique value, otherwise
    Vue.js will cache the component and the projects will fail to draw
    See: https://stackoverflow.com/questions/48400302/vue-js-not-updating-props-in-child-when-parent-component-is-changing-the-propert
-->

<template>
    <div>
        <div class="tile is-ancestor" v-for="(row, index) in rows" :key="index">
            <div class="tile" v-for="(project, index2) in row" :key="index2">
                <project-card
                    :project="project"
                    v-if="project">
                </project-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ProjectCardList',
  data () {
    return {
      rows: [
        // [<project>, <project>, <project>]
        // [<project>, <project>, <project>]
      ]
    }
  },
  mounted: function() {
    var currentRow = [],
        MAX_ROW_LENGTH = 3,
        that = this;

    this.projects.forEach(function(project) {
      if(currentRow.length !== MAX_ROW_LENGTH) {
        currentRow.push(project);
      }
      else {
        that.rows.push(currentRow);
        currentRow = [ project ];
      }
    });

    // push any leftovers
    if(currentRow.length > 0) {
        // this fills up the row so all rows are of equal length for CSS sizing
        while(currentRow.length < MAX_ROW_LENGTH) {
            currentRow.push(null);
        }
        this.rows.push(currentRow);
    }
  },
  props: ['projects']
}
</script>



// WEBPACK FOOTER //
// src/components/ProjectCardList.vue